var app = angular.module('leonardo');

var TemplateBaseForm = function (
  $scope,
  $window,
  ngDialog,
  TemplateService,
  AttachmentService,
  FilterService,
  $state,
  $q,
  AccountUserService,
  PermissionService,
  LevelService,
  UserService,
  CategoryVendorService,
  FolderService,
  FormErrorsService,
  AuthDataService,
  $rootScope,
  SubCategoryRestService,
  SectorRestService,
  $filter,
  FieldSubgroupService,
  WhiteLabelService,
  TranslationService,
  ClientInstanceService,
  AuthDataService
) {
  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.userService = UserService;
  $scope.filterService = FilterService;
  $scope.authDataService = AuthDataService;
  $scope.templateService = TemplateService;
  $scope.sectorRestService = SectorRestService;
  $scope.subCategoryRestService = SubCategoryRestService;
  $scope.categoryVendorService = CategoryVendorService;
  $scope.whiteLabelService = WhiteLabelService;
  $scope.clientInstanceService = ClientInstanceService;
  $scope.folderService = FolderService;
  $scope.init = false;

  $scope.templateMode = $state.current.templateMode ? $state.current.templateMode : 'property';
  $scope.action = $state.current.action;
  $scope.errorFields = '';

  $scope.lagTypes = TemplateService.LAG_TYPES;

  $scope.isNull = isNull;
  $scope.account = AccountUserService.currentAccountUser.account;
  $scope.accountObj = AuthDataService.authData.account;

  if (AuthDataService.isNotStaff()) {
    $scope.filtersAccountUsers = { disable_pagination: true, active: true, essential: true, user_is_active: true };
    if ($scope.action === 'create') {
      if ($scope.origin === 'task') {
        $scope.filtersAccountUsers['property'] = FilterService.currentProperty.id;
      } else {
        if ($state.params.properties) {
          $scope.filtersAccountUsers['property'] = $state.params.properties;
        }
        if ($state.params.portfolios) {
          $scope.filtersAccountUsers['portfolio'] = $state.params.portfolios;
        }
        if ($state.params.account) {
          $scope.filtersAccountUsers['account'] = $state.params.account;
        } else if (FilterService.currentProperty && FilterService.currentProperty.account) {
          $scope.filtersAccountUsers['account'] = FilterService.currentProperty.account.id
            ? FilterService.currentProperty.account.id
            : FilterService.currentProperty.account;
        }
      }
    } else {
      if ($scope.template.property) {
        $scope.filtersAccountUsers['property'] = $scope.template.property;
      } else if ($scope.template.portfolio) {
        $scope.filtersAccountUsers['portfolio'] = $scope.template.portfolio;
      } else if ($scope.template.account) {
        $scope.filtersAccountUsers['account'] = $scope.template.account;
      }
    }
    AccountUserService.getAvailableToAssign($scope.filtersAccountUsers).then(function (data) {
      $scope.usersAccount = data.results;
    });
  }

  $scope.accountUser = AccountUserService.getAccountUser($scope.template.account);

  $scope.initUsersRole = function (users) {
    var userIds = [];
    if (!isEmpty(users)) {
      angular.forEach(users, function (user) {
        if ($scope.usersAccount) {
          if ($scope.usersAccount.find((item) => item.id == user)) {
            userIds.push($scope.usersAccount.find((item) => item.id == user));
          }
        } else {
          userIds.push(user);
        }
      });
    }
    return userIds;
  };

  $scope.validationRole = function () {
    var valid = true;
    var account_users_assigned = angular.copy($scope.data.account_users_assigned);
    if (angular.isString(account_users_assigned)) {
      account_users_assigned = account_users_assigned.split(',');
    }
    var users_assigned = $scope.initUsersRole(account_users_assigned);
    if (!isEmpty(users_assigned) && !isEmpty($scope.data.role_based) && !isEmpty($scope.data.role_based.roles)) {
      angular.forEach(users_assigned, function (user) {
        if (!$scope.data.role_based.roles.find((item) => item === user.role)) {
          valid = false;
        }
      });
    }
    return valid;
  }

  $scope.roleValidation = {
    error: 'userRole',
    message: $filter('translate')('The user role of the individual(s) selected to automatically assign to the task should match at least one role selected in Role-based section'),
    validation: $scope.validationRole,
    eventWatch: 'users_roles:updated'
  }

  $scope.toggleTab = function (tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    } else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function (tab) {
    return $scope.tabsCollapsed.includes(tab);
  };

  $scope.getTemplateType = function () {
    if ($scope.data.root_group || !isNull($scope.data.group)) {
      return AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin() ? 'system' : 'account';
    }
    if ($scope.templateMode == 'template') {
      if (PermissionService.isOwner()) {
        if ($scope.action === 'create') {
          if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
            return 'system';
          }
          if ($state.params.portfolios || $state.params.properties) {
            return 'portfolio';
          } else {
            return 'account';
          }
        }
        if ($scope.template.type == TemplateService.TYPE_PORTFOLIO) {
          return 'portfolio';
        }
        return 'account';
      }
      return 'portfolio';
    }
    else {
      return $scope.templateMode;
    }
  };

  $scope.fieldsAvailable = function () {
    return $scope.templateMode !== 'owner';
  };

  $scope.onSectorChange = function () {
    FieldSubgroupService.getlist({ disable_pagination: true, sector: $scope.data.sector }).then(function (data) {
      $scope.fieldSubgroups = data;
      $scope.prepareFields();
    });
    if ($scope.data.sector) {
      $rootScope.$broadcast('filter-service:filter-changed', 'sector', $scope.data.sector);
    } else {
      $rootScope.$broadcast('filter-service:filter-removed', 'sector');
    }
  };

  $scope.groupVisible = function (group) {
    var anyVisible = false;

    angular.forEach(group.subgroups, function (subgroup) {
      if (subgroup.data['template_widget'] !== 'hidden') {
        anyVisible = true;
      }
    });
    return anyVisible;
  };

  $scope.getNumber = function (num) {
    return new Array(num);
  };

  $scope.initUsers = function (users) {
    var userIds = [];
    if (users) {
      var usersArray = angular.isArray(users) ? users : users.split(',');
      angular.forEach(usersArray, function (user) {
        if (user) {
          if (user.id) {
            userIds.push(user.id);
          } else {
            userIds.push(user);
          }
        }
      });
    }
    return userIds;
  };

  $scope.alterData = function (data) {
    data.fields = {};
    angular.forEach($scope.field_data, function (value, key) {
      if (value) data.fields[key] = value;
    });
  };

  $scope.prepareFields = function () {
    var groups = {};
    $scope.fields = [];

    var otherGroup = {
      key: '-other-',
      name: 'Other',
      subgroups: []
    };

    angular.forEach($scope.fieldSubgroups, function (subgroup) {
      var group = null;
      if (!subgroup.group) {
        otherGroup.subgroups.push(subgroup);
        return;
      }
      if (subgroup.group.key in groups) {
        group = groups[subgroup.group.key];
      } else {
        group = {
          key: subgroup.group.key,
          name: subgroup.group.name,
          subgroups: []
        };
        groups[subgroup.group.key] = group;
        $scope.fields.push(group);
      }
      group.subgroups.push(subgroup);
    });
    $scope.fields.push(otherGroup);
  };

  $scope.overridableInitParams = function () {
    $scope.field_data = $scope.template.fields;

    $scope.prepareFields();
  };

  $scope.initParams = function () {
    if ($scope.template.locale && $scope.getLocaleLength($scope.template) > 0) {
      let keys = Object.keys($scope.template.locale);
      if (!keys.includes('en')) {
        $scope.template.locale['en'] = { "body": $scope.template.body , "name": $scope.template.name }
        $scope.localeAdded = true;
      }
    }
    $scope.data = {
      name: $scope.template.name,
      client_instance: $scope.template.client_instance || AuthDataService.getClientInstance(),
      //white_label: $scope.template.white_label || AuthDataService.getWhiteLabel(),
      account: $scope.template.account,
      portfolio: $scope.template.portfolio,
      property: $scope.template.property,
      body: $scope.template.body,
      type: $scope.template.type,
      category: $scope.template.category,
      subcategory: $scope.template.subcategory,
      role_based: {
        roles: !isNull($scope.template.roles)
          ? $scope.template.roles.map(function (obj) {
              if (obj.id) return obj.id;
              else return obj;
            })
          : [],
        role_based_only: !isNull($scope.template.role_based_only) ? $scope.template.role_based_only : false
      },
      dynamic_form: $scope.template.dynamic_form,
      vendor_category: $scope.template.vendor_category,
      note_required: $scope.template.note_required,
      attachment_required: $scope.template.attachment_required,
      approval_steps: $filter('orderBy')($scope.template.approval_steps, 'index'),
      enabled: $scope.template.status == TemplateService.STATUS_PUBLISHED,
      never_fall_off: $scope.template.never_fall_off,
      novice: $scope.template.novice,
      value_item: $scope.template.value_item,
      recurrence: {
        type: !isNull($scope.template.recurrence_type) ? $scope.template.recurrence_type.toString() : null,
        recurrence: angular.copy($scope.template.recurrence)
      },
      priority: $scope.template.priority,
      attachments: [],
      seasonal: {
        from: $scope.template.date_from,
        to: $scope.template.date_to
      },
      sector: $scope.template.sector,
      permanence: $scope.template.permanence,
      days_before_ai_creation: !isNull($scope.template.days_before_ai_creation) ? $scope.template.days_before_ai_creation : 0,
      auto_start: $scope.template.auto_start,
      track_time: $scope.template.track_time,
      ignore_office_hours: $scope.template.ignore_office_hours,
      fields: $scope.template.fields,
      account_users_assigned: $scope.initUsers($scope.template.account_users_assigned),
      notify_to: $scope.template.notify_to,
      notify_at_start: $scope.template.notify_at_start,
      notify_at_complete: $scope.template.notify_at_complete,
      notify_at_approval_complete_users: $scope.initUsers($scope.template.notify_at_approval_complete_users),
      notify_at_approval_complete_emails: $scope.template.notify_at_approval_complete_emails,
      notify_at_approval_complete_contact_types: $scope.template.notify_at_approval_complete_contact_types,
      notify_at_approval_terminated_users: $scope.initUsers($scope.template.notify_at_approval_terminated_users),
      notify_at_approval_terminated_emails: $scope.template.notify_at_approval_terminated_emails,
      notify_at_approval_terminated_contact_types: $scope.template.notify_at_approval_terminated_contact_types,
      contact_types: $scope.template.contact_types,
      notify_include_attachments: $scope.template.notify_include_attachments,
      group: $scope.template.group,
      root_group: $scope.template.root_group,
      languages: ($scope.template.languages && $scope.template.languages.length > 0) ? $scope.template.languages.map(lang => lang.id) : ['2'],
      translation : ($scope.template.languages && $scope.template.languages.length > 0) ? true : false,
      created_in_language: $scope.template.created_in_language ? $scope.template.created_in_language : 'en',
      updated_in_language: $scope.template.updated_in_language ? $scope.template.updated_in_language : 'en',
      locale: $scope.template.locale
    };

    var levels = {
      country: $scope.template.country ? $scope.template.country.id || $scope.template.country : null,
      state: [],
      county: [],
      city: [],
      zipcode: []
    };

    angular.forEach($scope.template.levels, function (value) {
      if (!isNull(value.level_type)) {
        switch (value.level_type) {
          case LevelService.TYPE_STATE:
            levels.state.push(value.id);
            break;
          case LevelService.TYPE_COUNTY:
            levels.county.push(value.id);
            break;
          case LevelService.TYPE_CITY:
            levels.city.push(value.id);
            break;
          case LevelService.TYPE_ZIPCODE:
            levels.zipcode.push(value.id);
            break;
        }
      }
    });

    if ($scope.template.state) {
      levels.state = $scope.template.state;
    }
    if ($scope.template.county) {
      levels.county = $scope.template.county;
    }
    if ($scope.template.city) {
      levels.city = $scope.template.city;
    }
    if ($scope.template.zipcode) {
      levels.zipcode = $scope.template.zipcode;
    }

    $scope.data.levels_data = levels;

    if ($scope.action === 'create') {
      $scope.data.enabled = true;
    }

    if ($scope.data.recurrence.type === null || $scope.data.recurrence.type === undefined) {
      $scope.data.recurrence.type = TemplateService.RECURRENCE_WEEKLY;
      $scope.data.recurrence.recurrence = {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true
      };
    }
    var promises = [];

    if ($scope.template.attachments && $scope.template.attachments.length > 0) {
      var ids = $scope.template.attachments.map(function (obj) {
        return obj.id ? obj.id : obj;
      });
      var filters = {
        disable_pagination: true,
        id: ids.join(',')
      };
      promises.push(
        AttachmentService.getlist(filters).then(function (data) {
          $scope.data.attachments = data.results ? data.results : data;
        })
      );
    }

    if ($scope.templateMode === 'owner') {
      $scope.data.account_user = AccountUserService.currentAccountUser.id;
    }

    $scope.overridableInitParams();

    $q.all(promises).then(function () {
      $scope.init = true;
    });
  };

  $scope.removeAttachment = function (index) {
    $scope.data.attachments.splice(index, 1);
  };

  $scope.sortApprovalsSteps = function () {
    angular.forEach($scope.data.approval_steps, function (step, index) {
      step.index = index + 1;
    });
  };

  $scope.showAttachment = function (index) {
    if ($scope.data.attachments[index].document_file) {
      // Use signed_view_url for secure inline viewing
      $window.open($scope.data.attachments[index].document_file.signed_view_url || $scope.data.attachments[index].document_file.secure_share_url);
    } else if ($scope.data.attachments[index].link) {
      $window.open($scope.data.attachments[index].link);
    } else {
      if (angular.isObject($scope.data.attachments[index].file)) {
        var reader = new FileReader();
        reader.addEventListener(
          'load',
          function () {
            ngDialog.open({
              template: 'views/templates/dialog/show-image.html',
              className: 'ngdialog-theme-default ngdialog-attachments-view',
              data: {
                name: $scope.data.attachments[index].name,
                src: reader.result
              }
            });
          },
          false
        );
        reader.readAsDataURL($scope.data.attachments[index].file);
      } else {
        // Use signed_view_url for secure inline viewing
        $window.open($scope.data.attachments[index].signed_view_url || $scope.data.attachments[index].secure_share_url || $scope.data.attachments[index].file);
      }
    }
  };

  $scope.showAttachDialog = function () {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/attachment/upload.html',
        controller: 'AttachmentUploadDialog',
        data: {
          task: $scope.data,
          mode: 'upload',
          showManagement: true,
          account: $scope.data.account
        }
      })
      .then(function (attachments) {
        $scope.data.attachments = [];
        angular.forEach(attachments, function (attachment) {
          $scope.data.attachments.push(attachment);
        });
      }, function () {
        return;
      });
  };

  $scope.showAddApprovalDialog = function () {
    if (isNull($scope.data.approval_steps)) {
      $scope.data.approval_steps = [];
    }
    if(!$scope.data.property){
      $scope.data.property = $scope.filtersAccountUsers['property'];
    }
    if(!$scope.data.portfolio){
      $scope.data.portfolio = $scope.filtersAccountUsers['portfolio'];
    }
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: { index: $scope.data.approval_steps.length + 1 },
          action: 'create'
        }
      })
      .then(function (result) {
        if (result.index === $scope.data.approval_steps.length + 1) {
          $scope.data.approval_steps.push(result);
        } else {
          $scope.data.approval_steps.splice(result.index - 1, 0, result);
          $scope.sortApprovalsSteps();
        }
      }, function () {
        return;
      });
  };

  $scope.showEditApprovalDialog = function (index) {
    const approval = angular.copy($scope.data.approval_steps[index]);
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: approval,
          action: 'edit'
        }
      })
      .then(function (result) {
        if (index === result.index - 1) {
          $scope.data.approval_steps[index] = result;
        } else {
          $scope.data.approval_steps.splice(index, 1);
          $scope.data.approval_steps.splice(result.index - 1, 0, result);
          $scope.sortApprovalsSteps();
        }
      }, function () {
        return;
      });
  };

  $scope.deleteApproval = function (index) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/delete-approval.html',
        controller: 'DeleteApprovalStepDialog',
        data: {
          object: $scope.data.approval_steps[index]
        }
      })
      .then(function () {
        $scope.data.approval_steps.splice(index, 1);
        angular.forEach($scope.data.approval_steps, function (approval, indexNew) {
          if (indexNew >= index) {
            approval.index--;
          }
        });
      }, function () {
        return;
      });
  };

  // Returns true if the browser is Firefox
  $scope.isFirefox = function() {
    return navigator.userAgent.includes("Firefox");
  };

  $scope.getStandardDate = function(mmdDate) {
    if ($scope.isFirefox()) {
      // Parse MM-DD (e.g., "02-12") and set current year
      const date = moment(mmdDate, "MM-DD");
      // Now format as YYYY-MM-DD (e.g., "2023-02-12")
      return date.format("YYYY-MM-DD");
    } else {
      return mmdDate;
    }
  };

  $scope.getData = function (edit) {
    var data = angular.copy($scope.data);
    delete data.seasonal;
    if ($scope.data.seasonal) {
      data.date_from = $scope.data.seasonal.from ? $scope.getStandardDate($scope.data.seasonal.from) : null;
      data.date_to = $scope.data.seasonal.to ? $scope.getStandardDate($scope.data.seasonal.to) : null;
    }

    delete data.recurrence;
    if ($scope.data.recurrence && !$scope.data.root_group) {
      data['recurrence'] = $scope.data.recurrence.recurrence;
      data['recurrence_type'] = $scope.data.recurrence.type;
    }

    delete data.role_based;
    if ($scope.data.role_based) {
      data['roles'] = $scope.data.role_based.roles;
      data['role_based_only'] = $scope.data.role_based.role_based_only;
    }

    data['status'] = $scope.data.enabled ? TemplateService.STATUS_PUBLISHED : TemplateService.STATUS_UNPUBLISHED;
    delete data['enabled'];

    if($scope.data.languages){
      $scope.data.languages = angular.isArray($scope.data.languages) ? $scope.data.languages : $scope.data.languages.split(',');
    }
    // need to manage the languages when translation is off then language should be blank array
    if($scope.data.translation && $scope.data.languages && $scope.data.languages.length > 0){
      data.languages = $scope.data.languages.map(Number);
    }
    else {
      data.languages = [];
    }
    if($scope.localeAdded){
      delete data.locale['en'];
    }
    delete data['translation'];

    if (!edit) {
      if ($scope.data.approval_steps) {
        angular.forEach($scope.data.approval_steps, function (approval, index) {
          data['approval_steps'][index]['user_approvers'] = !isEmpty(approval.user_approvers)
            ? approval.user_approvers.map((item) => parseInt(item.id || item))
            : [];
          data['approval_steps'][index]['user_role_approvers'] = !isEmpty(approval.user_role_approvers)
            ? approval.user_role_approvers.map((item) => parseInt(item.id || item))
            : [];
          data['approval_steps'][index]['secondary_user_approvers'] = !isEmpty(approval.secondary_user_approvers)
            ? approval.secondary_user_approvers.map((item) => parseInt(item.id || item))
            : [];
            data['approval_steps'][index]['secondary_user_role_approvers'] = !isEmpty(approval.secondary_user_role_approvers)
            ? approval.secondary_user_role_approvers.map((item) => parseInt(item.id || item))
            : [];
        });
      }
      data.account_users_assigned = $scope.initUsers(data.account_users_assigned);
      data.notify_at_approval_complete_users = $scope.initUsers(data.notify_at_approval_complete_users);
      data.notify_at_approval_terminated_users = $scope.initUsers(data.notify_at_approval_terminated_users);

      data.notify_to = [];

      angular.forEach($scope.data.notify_to, function (email) {
        if (email) data.notify_to.push(email);
      });

      data.attachments = [];
      angular.forEach($scope.data.attachments, function (attachment) {
        data.attachments.push(attachment.id ? attachment.id : attachment);
      });

      if ($scope.data.managed_by) {
        data['managed_by'] = $scope.data.managed_by.id;
      }

      data.country = data.levels_data.country;
      data.levels = [];
      angular.forEach(data.levels_data, function (level_type, key) {
        if (!isEmpty(level_type) && key !== 'country') {
          var levels = !angular.isArray(level_type) ? level_type.toString().split(',') : level_type;
          angular.forEach(levels, function (level) {
            data.levels.push(level);
          });
        }
      });

      delete data.levels_data;

      if ($scope.alterData) {
        $scope.alterData(data);
      }
    }

    delete data.state;
    delete data.county;
    delete data.city;
    delete data.zipcode;

    return data;
  };

  $scope.getNameAccount = function (account) {
    var array_account = [];
    if (account) array_account = angular.isArray(account) ? account : account.split(',');
    var labels = [];
    angular.forEach(array_account, function (account_id) {
      if (AuthDataService.authData.account) {
        angular.forEach(AuthDataService.authData.account.managed_to_me, function (managed) {
          if (managed.id == account_id) {
            labels.push(managed.name);
          }
        });
      }
    });
    return labels.join(',');
  };

  $scope.getApprovalName = function (user) {
    return $filter('username')(user) + ' - ' + user.email;
  };

  $scope.containsId = function (array, id) {
    var contains = false;
    angular.forEach(array, function (value) {
      if (value.id === id) contains = true;
    });
    return contains;
  };

  $scope.submitActive = function () {
    if (!$scope.template) {
      return false;
    }
    if ($scope.onboarding) {
      return true;
    }
    if ($state.current.action === 'create') {
      return true;
    }
    return $scope.template.editable;
  };

  $scope.overrideActive = function () {
    if (!$scope.template) {
      return false;
    }
    if ($scope.onboarding) {
      return false;
    }
    if ($state.current.action === 'create') {
      return false;
    }
    return !$scope.template.editable && $scope.template.overridable;
  };

  $scope.override = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    switch ($scope.templateMode) {
      case 'property':
        data['type'] = TemplateService.TYPE_PROPERTY;
        data['property'] = FilterService.getFilter('property');
        data['parent'] = $scope.template.id;
        TemplateService.post(data).then(function () {
          $rootScope.$broadcast('template:created');
        });
        break;
      case 'trigger':
        data['type'] = TemplateService.TYPE_TRIGGER;
        data['parent'] = $scope.template.id;
        data['account'] = AccountUserService.currentAccountUser.account;
        TemplateService.post(data).then(function () {
          $rootScope.$broadcast('template-trigger:created');
        });
        break;
      case 'template':
        if (data.root_group || !isNull(data.group)) {
          if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
            data['type'] = TemplateService.TYPE_SYSTEM;
            delete data['account'];
          } else {
            data['type'] = TemplateService.TYPE_ACCOUNT;
          }
          TemplateService.post(data).then(function () {
            $rootScope.$broadcast('template:created');
          });
        } else {
          ngDialog
            .openConfirm({
              controller: 'PortfolioPropertySelectorDialog',
              templateUrl: 'views/templates/dialog/portfolio/selector.html',
              data: {
                account: data.account
              }
            })
            .then(function (results) {
              var all = [];
              if (results.type === 'account') {
                var templateData = angular.copy(data);
                templateData['type'] = TemplateService.TYPE_ACCOUNT;
                templateData['parent'] = $scope.template.id;
                templateData['account'] = AccountUserService.currentAccountUser.account;
                all.push(TemplateService.post(templateData));
              } else {
                if (results.portfolios) {
                  angular.forEach(results.portfolios, function (portfolio) {
                    var templateDataPortfolio = angular.copy(data);
                    templateDataPortfolio['type'] = TemplateService.TYPE_PORTFOLIO;
                    templateDataPortfolio['parent'] = $scope.template.id;
                    templateDataPortfolio['portfolio'] = portfolio;
                    all.push(TemplateService.post(templateDataPortfolio, true));
                  });
                }
                if (results.properties) {
                  angular.forEach(results.properties, function (property) {
                    var templateDataProperty = angular.copy(data);
                    templateDataProperty['type'] = TemplateService.TYPE_PROPERTY;
                    templateDataProperty['parent'] = $scope.template.id;
                    templateDataProperty['property'] = property;
                    all.push(TemplateService.post(templateDataProperty, true));
                  });
                }
              }
              $q.all(all).then(function () {
                $rootScope.$broadcast('template:created');
              });
            }, function () {
              return;
            });
        }

        break;
    }
  };

  $scope.clone = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var templateData = $scope.getData();
    templateData['id'] = $scope.template.id;
    if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/admin/clone-element.html',
          controller: 'CloneTypeDialog',
          className: 'ngdialog-theme-default ngdialog-select-account',
          data: {
            type: 'template'
          }
        })
        .then(function (result) {
          if (result.type_result === 'client_instance') {
            $scope.template.cloneToWhiteLabel({ whitelabels: result.client_instance }).then(function () {
              $scope.loadPage($scope.page);
            });
          } else {
            TemplateService.post(templateData).then(function (template) {
              $rootScope.$broadcast('template:created');
            });
          }
        }, function () {
          return;
        });
    } else {
      if ($scope.templateMode === 'trigger') {
        templateData['type'] = TemplateService.TYPE_TRIGGER;
        templateData['account'] = AccountUserService.currentAccountUser.account;
        delete templateData['parent'];
        delete templateData['portfolio'];
        delete templateData['property'];
        TemplateService.post(templateData).then(function () {
          $rootScope.$broadcast('template-trigger:created');
        });
      } else {
        if (templateData.root_group || !isNull(templateData.group)) {
          if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
            templateData['type'] = TemplateService.TYPE_SYSTEM;
            delete templateData['account'];
          } else {
            templateData['type'] = TemplateService.TYPE_ACCOUNT;
          }
          TemplateService.post(templateData).then(function () {
            $rootScope.$broadcast('template:created');
          });
        } else {
          ngDialog
            .openConfirm({
              controller: 'PortfolioPropertySelectorDialog',
              templateUrl: 'views/templates/dialog/portfolio/selector.html',
              data: {
                clone: true,
                account: templateData.account,
                template: templateData
              }
            })
            .then(function (results) {
              var all = [];
              if (results.type === 'account') {
                templateData['type'] = TemplateService.TYPE_ACCOUNT;
                templateData['account'] = AccountUserService.currentAccountUser.account;
                delete templateData['parent'];
                delete templateData['portfolio'];
                delete templateData['property'];
                all.push(TemplateService.post(templateData));
              } else {
                if (results.portfolios && results.portfolios.length > 0) {
                  angular.forEach(results.portfolios, function (portfolio) {
                    templateData['type'] = TemplateService.TYPE_PORTFOLIO;
                    templateData['portfolio'] = portfolio;
                    delete templateData['property'];
                    all.push(TemplateService.post(templateData, true));
                  });
                }
                if (results.properties) {
                  angular.forEach(results.properties, function (property) {
                    templateData['type'] = TemplateService.TYPE_PROPERTY;
                    templateData['property'] = property;
                    delete templateData['portfolio'];
                    all.push(TemplateService.post(templateData, true));
                  });
                }
              }
              $q.all(all).then(function () {
                $rootScope.$broadcast('template:created');
              });
            }, function () {
              return;
            });
        }
      }
    }
  };

  $scope.getErrors = function () {
    var fields = [];
    angular.forEach($scope.Form.$error, function(error_type){
      angular.forEach(error_type, function (error) {
        if (error.$name && error.$name !== 'Field') {
          var name = error.$name.split('_').join(' ');
          fields.push('"' + capitalize(name) + '"');
        }
      });
    });
    $scope.errorFields = fields.length > 0 ? fields.join(',  ') : '';
  }

  $scope.updateTranslations = function (field_name){
    if($scope.template.locale && Object.keys($scope.template.locale).length > 0 && ($scope.data.created_in_language == $scope.data.updated_in_language)){
      let translate_lang = Object.keys($scope.template.locale).filter(key => (key != $scope.data.updated_in_language));
      let context = {id: field_name, value:  $scope.template.locale[$scope.data.updated_in_language][field_name]}
      let request = {
        original_lang: $scope.data.updated_in_language,
        translate_lang: (translate_lang && translate_lang.length > 0) ? translate_lang : ['en'],
        context: context
      }
      TranslationService.post(request).then(function (result) {
        if (result && result.context && result.context.length > 0) {
          result.context.forEach(translated_data => {
            translated_data.forEach(loc => {
              Object.keys(loc).forEach(lang_code => {
                $scope.data.locale[lang_code][field_name] = loc[lang_code]['value'];
              })
            })
          })
          $scope.data[field_name] = $scope.data.locale['en'][field_name];
        }
      }).catch(err =>{
      });
    }
  }

  $scope.getLocaleLength = function(template){
    let keys = Object.keys(template.locale);
    return keys.length;
  }

  $scope.changeSelectedTab = function(lang){
    $scope.data.updated_in_language = lang;
  }

  $scope.$watch('data.role_based.roles', function (newValue,oldValue) {
    if (!angular.equals(newValue, oldValue)) {
      $rootScope.$broadcast('users_roles:updated');
    }
  });
};

app.controller('TemplateBaseForm', [
  '$scope',
  '$window',
  'ngDialog',
  'TemplateService',
  'AttachmentService',
  'FilterService',
  '$state',
  '$q',
  'AccountUserService',
  'PermissionService',
  'LevelService',
  'UserService',
  'CategoryVendorService',
  'FolderService',
  'FormErrorsService',
  'AuthDataService',
  '$rootScope',
  'SubCategoryRestService',
  'SectorRestService',
  '$filter',
  'FieldSubgroupService',
  'WhiteLabelService',
  'TranslationService',
  'ClientInstanceService',
  'AuthDataService',
  TemplateBaseForm
]);
